export const CRM_OBJECT_PIPELINE_SETTINGS = 'crm_object_pipelines';